export default __webpack_public_path__ + "static/media/cpp.8747b38f.svg";